var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "inviteCreate" } }, [
    _c(
      "div",
      { staticClass: "dialog-content" },
      [
        _vm.action === "selected-unit"
          ? _c("div", { staticClass: "context" }, [
              _vm._v(
                "\n      To invite a user to this unit, enter their email address and select a role. You can also "
              ),
              _c(
                "span",
                { staticClass: "vo-link", on: { click: _vm.addExistingUser } },
                [_vm._v("add an existing user")]
              ),
              _vm._v(" to this unit.")
            ])
          : _c("div", { staticClass: "context" }, [
              _vm._v(
                "To invite a user, enter an email address, select a role template, and select any extra information required for their role."
              )
            ]),
        _vm._v(" "),
        _c("v-text-field", {
          ref: "inputEmail",
          attrs: {
            label: "Email",
            type: "email",
            "prepend-icon": "mdi-account-plus",
            rules: _vm.rules.email,
            "validate-on-blur":
              _vm.$refs.inputEmail && _vm.$refs.inputEmail.valid
          },
          model: {
            value: _vm.invite.email,
            callback: function($$v) {
              _vm.$set(_vm.invite, "email", $$v)
            },
            expression: "invite.email"
          }
        }),
        _vm._v(" "),
        _c("v-select", {
          ref: "selectRole",
          attrs: {
            label: "Role",
            "prepend-icon": "mdi-clipboard-account",
            "item-text": "title",
            "item-value": "_id",
            items: _vm.roleTemplates,
            rules: _vm.rules.role
          },
          model: {
            value: _vm.invite.role,
            callback: function($$v) {
              _vm.$set(_vm.invite, "role", $$v)
            },
            expression: "invite.role"
          }
        }),
        _vm._v(" "),
        _vm.showProperty
          ? _c("v-select", {
              ref: "selectProperty",
              attrs: {
                label: "Property",
                "prepend-icon": "mdi-domain",
                "item-text": "name",
                "item-value": "_id",
                items: _vm.properties,
                rules: _vm.rules.property,
                disabled: _vm.action === "selected-unit"
              },
              model: {
                value: _vm.invite.property,
                callback: function($$v) {
                  _vm.$set(_vm.invite, "property", $$v)
                },
                expression: "invite.property"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showUnit
          ? _c("v-select", {
              ref: "selectUnit",
              attrs: {
                label: "Unit",
                "prepend-icon": "mdi-home",
                "item-text": "title",
                "item-value": "_id",
                rules: _vm.rules.unit,
                items: _vm.units,
                disabled:
                  !_vm.invite.property || _vm.action === "selected-unit",
                "search-input": _vm.unitSearch,
                loading: _vm.invite.property && _vm.unitsLoading,
                autocomplete: ""
              },
              on: {
                "update:searchInput": function($event) {
                  _vm.unitSearch = $event
                }
              },
              model: {
                value: _vm.invite.unit,
                callback: function($$v) {
                  _vm.$set(_vm.invite, "unit", $$v)
                },
                expression: "invite.unit"
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { disabled: _vm.lockout.on, flat: "", color: "info" },
            on: {
              click: function($event) {
                _vm.routeRemoveQuery("dialog")
              }
            }
          },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { loading: _vm.lockout.on, flat: "", color: "primary" },
            on: { click: _vm.create }
          },
          [_vm._v("Create")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bebeb15", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bebeb15","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InviteCreate.vue
// module id = 500
// module chunks = 4